import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import { DebounceInputSearch, UFInput } from "../../../components/Common/Fields/Input"
import Status from "../../../components/Common/chooseFields/status"
import { useForm } from "react-hook-form"
import { Form } from "reactstrap"
import exportIcon from "../../../assets/icons/export.svg"
import {
  importFileData,
  sampleFileDownload,
} from "../../../services/Inventory/inventory"
import closeIcon from "../../../assets/icons/close.svg"
import uploadicon from "../../../assets/icons/import.svg"
import Country from "../../../components/Common/chooseFields/country"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import LoadingButton from "../../../components/Common/LoadingButton"
import resetIcon from "../../../assets/icons/reset.svg"
import FinanceGroupType from "../../../components/Common/chooseFields/financeGroupType"

const LedgerFilter = ({
  handleStatusChange,
  handleSearchChange,
  handleCountryChange,
  handleGroupChange,
  sampleUrl,
  importUrl,
  isImport,
  handilGroupdata,
  searchedText,
  hideGroupFilter,
}) => {
  const [modal, setModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [resets, setReset] = useState(false)

  const { control, watch, reset, setValue } = useForm()
  const initialSearchSetRef = useRef(false)

  const toggle = () => {
    setModal(!modal)
    setFile()
    setFileName()
  }

//   useEffect(() => {
//   setValue(
//     "account_group_id",
//     handilGroupdata
//       ? { label: handilGroupdata.label, value: handilGroupdata.value }
//       : null,
//     { shouldValidate: false, shouldDirty: false }
//   )
//   setValue("search", searchedText ? searchedText : "", { shouldValidate: false, shouldDirty: false })
// }, [handilGroupdata, setValue, searchedText])

useEffect(() => {
   setValue(
     "account_group_id",
     handilGroupdata
       ? { label: handilGroupdata.label, value: handilGroupdata.value }
       : null,
     { shouldValidate: false, shouldDirty: false }
   )
   // set initial search from prop only once (don't overwrite while user types)
   if (searchedText && !initialSearchSetRef.current) {
     setValue("search", searchedText, { shouldValidate: false, shouldDirty: false })
     initialSearchSetRef.current = true
   }
}, [handilGroupdata, setValue, searchedText])

  const handleStatus = data => {
    handleStatusChange(data?.value)
  }
  const handleCountry = data => {
    handleCountryChange(data?.value)
  }
  const handleGroup = data => {
    handleGroupChange(data)
  }

  const handleSampleFile = () => {
    const handleCommonExport = async () => {
      const response = await sampleFileDownload(sampleUrl)
    }
    handleCommonExport()
  }

  // useEffect(() => {
  //   if (resets) {
  //     handleSearchChange("")
  //     setValue("search", resets && "", { shouldValidate: false, shouldDirty: false })
  //   } else {
  //     handleSearchChange(watch("search"))
  //   }
  //   console.log("searchasasas", watch("search"))
  // }, [watch("search")])

  const searchValue = watch("search")

//   useEffect(() => {
//    if (resets) {
//      // perform reset once and clear the resets flag
//      handleSearchChange("")
//      setValue("search", "", { shouldValidate: false, shouldDirty: false })
//      setReset(false)
//      initialSearchSetRef.current = false // allow next incoming searchedText to set initial value again
//    } else {
//      handleSearchChange(searchValue)
//    }
//  }, [searchValue, resets, handleSearchChange, setValue])

const prevSearchRef = useRef("")
const debounceRef = useRef(null)

useEffect(() => {
  // handle explicit reset immediately
  if (resets) {
    handleSearchChange("")
    setValue("search", "", { shouldValidate: false, shouldDirty: false })
    setReset(false)
    initialSearchSetRef.current = false
    prevSearchRef.current = ""
    return
  }

  const current = searchValue ?? ""

  // if value didn't change, don't call parent
  if (current === prevSearchRef.current) return

  // debounce parent call
  if (debounceRef.current) clearTimeout(debounceRef.current)
  debounceRef.current = setTimeout(() => {
    prevSearchRef.current = current
    handleSearchChange(current)
  }, 300)

  return () => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
      debounceRef.current = null
    }
  }
}, [searchValue, resets, handleSearchChange, setValue])

  const [file, setFile] = useState()
  const [fileName, setFileName] = useState()

  const onFileChange = event => {
    setFileName(event)
    setFile(event?.target?.files?.[0])
  }

  const handleImport = () => {
    const importFile = async () => {
      try {
        setIsLoading(true)
        const response = await importFileData({
          importfile: file,
          url: importUrl,
        })
        toastSuccess(response?.message)
        setModal(false)
      } catch (err) {
        toastError(err?.message)
      } finally {
        setIsLoading(false)
      }
    }
    importFile()
  }

  const handleReset = (data) => {
    setReset(data)
    handleStatusChange()
    handleSearchChange()
    handleCountryChange()
    handleGroupChange()
    reset({
      search: "",
      account_group_id: null,
      country_id: null,
      status: null,
    })
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-2 me-2">
        <Form id="user-form" className="filter-wrapper">
          <Row className="mx-0">
            {/* Subledgers all sit in the one subledger group, so filtering by group there is
                meaningless — that tab gets search only. */}
            {!hideGroupFilter && (
            <Col sm={3}>
              <FinanceGroupType
                control={control}
                placeholder="Select by Group"
                name={"account_group_id"}
                // invalid={!!errors.account_group_id}
                target={"body"}
                onSelectChange={e => handleGroup(e)}
              />
            </Col>
            )}
            {/* <Col sm={3} className="pe-1">
              <Country
                control={control}
                name={"country_id"}
                placeholder={"Country"}
                target={"body"}
                onSelectChange={e => handleCountry(e)}
              />
            </Col>
            <Col sm={2} className="pe-1">
              <Status
                control={control}
                name={"status"}
                onSelectChange={e => handleStatus(e)}
              />
            </Col> */}
          </Row>
        </Form>
        <div className="d-flex">
          <div
            className="export-div pointer me-2 reset-img"
            onClick={() => handleReset(true)}
          >
            <img src={resetIcon} height={15} width={15} className="me-2" />{" "}
            Reset
          </div>
          <DebounceInputSearch
            control={control}
            placeholder={"Search by Ledger"}
            name={"search"}
            className={"search-input"}
            minLength={1}
            debounceTimeout={700}
          />
          {/* <UFInput
            control={control}
            placeholder="Search by Ledger"
            name={"search"}
            className={"search-input"}
          /> */}
          {isImport && (
            <div className="export-div pointer" onClick={() => toggle()}>
              <img src={exportIcon} />
            </div>
          )}
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <ModalHeader className="custom-modal-header">
          <div className="d-flex justify-content-between">
            <h5>{"Bulk Upload"}</h5>
            <img
              src={closeIcon}
              alt=""
              onClick={() => setModal(false)}
              width="10"
              role="button"
            />
          </div>
        </ModalHeader>

        <ModalBody>
          <div className="d-flex p-5 my-3">
            <Col className="file-import-div me-3 ">
              <label htmlFor="upload" className="m-0 pointer">
                <input
                  type="file"
                  id="upload"
                  name="upload"
                  accept=".xls,.xlsx"
                  onChange={event => {
                    onFileChange(event)
                  }}
                />
                {fileName ? (
                  <span>{fileName?.target?.files?.[0]?.name}</span>
                ) : (
                  <>
                    <img
                      src={uploadicon}
                      alt="Upload Excel"
                      className="upload-icon me-2 "
                    />
                    <span className="upload">Upload&nbsp;</span>
                    <span>the file</span>
                  </>
                )}
              </label>
            </Col>
            {/* <button
              className="btn btn-primary"
              type="submit"
              onClick={handleImport}
            >
              Import
            </button> */}
            <LoadingButton
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              className="btn btn-primary"
              type="submit"
              onClick={handleImport}
            >
              Import
            </LoadingButton>
          </div>
        </ModalBody>
        <ModalFooter className="bulk-upload-footer">
          <Row className="d-flex justify-content-center">
            <Col lg={8} className="text-center">
              Please download the sample file, add items, price etc & upload it
              back to create your Documents
            </Col>
          </Row>
          <Row
            className="fw-bold d-flex justify-content-center w-100 pointer"
            onClick={() => handleSampleFile()}
          >
            Download Sample File &gt;
          </Row>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default LedgerFilter
